export default __webpack_public_path__ + "static/media/anodu.98af0b67.png";